import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Bill } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatDateOnly, toDisplayDateOnly } from "@helpers/date";
import styles from "./DateCell.module.scss";

export const DateCell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, Bill, string | Date | null>) => (
        <ViewTableCell className={styles.dateCell}>
            {formatDateOnly(toDisplayDateOnly(getValue()))}
        </ViewTableCell>
    ),
);
